import { render, staticRenderFns } from "./HistoryMeasure.vue?vue&type=template&id=04616cb4&scoped=true"
import script from "./HistoryMeasure.vue?vue&type=script&lang=js"
export * from "./HistoryMeasure.vue?vue&type=script&lang=js"
import style0 from "./HistoryMeasure.vue?vue&type=style&index=0&id=04616cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04616cb4",
  null
  
)

export default component.exports